import Component from './ResetPasswordAnimation.vue';

export default Component;
